export default {
    label_task:{
        en:"Distributor vs Dealer Sales Report",
        bn:'Variety Report'
    },
    label_achievement :{
        en:"(%) Dealer Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_target:{
        en:"Target",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_sales_net:{
        en:"Net Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_sales_gross:{
        en:"Gross Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_sales_cancel:{
        en:"Canceled Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_quantity_difference:{
        en:"Balance",
        bn:'ব্যবহারকারীরা'
    },

}